function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m63.723 30.521a31.994 31.994 0 0 0-63.722 4.1673 31.669 31.669 0 0 0 10.022 23.228 12.904 12.904 0 0 0 8.9425 3.4341h26.041a13.315 13.315 0 0 0 9.3557-3.81 31.845 31.845 0 0 0 9.3611-27.019zm-13.088 23.196a7.9986 7.9986 0 0 1-5.6284 2.3009h-26.041a7.6307 7.6307 0 0 1-5.2818-1.9757 26.395 26.395 0 0 1-8.3506-19.354 26.699 26.699 0 0 1 8.8998-19.882 26.345 26.345 0 0 1 17.725-6.7802 28.136 28.136 0 0 1 3.1301 0.17597 26.646 26.646 0 0 1 15.547 45.528zm-29.819-7.604a2.6678 2.6678 0 1 1-3.7327 3.8127 21.33 21.33 0 0 1 17.96-36.351 2.6662 2.6662 0 0 1 2.2583 3.0208 2.6369 2.6369 0 0 1-3.0208 2.2609 15.997 15.997 0 0 0-13.464 27.257zm32.293-14.472a21.522 21.522 0 0 1 0.21596 3.0475 21.146 21.146 0 0 1-6.4202 15.24 2.6697 2.6697 0 0 1-3.7327-3.818 15.944 15.944 0 0 0 4.6499-13.707 2.6683 2.6683 0 1 1 5.2818-0.76254zm-15.979 1.6824a5.4204 5.4204 0 1 1-3.77-3.77l10.081-10.081a2.6662 2.6662 0 1 1 3.77 3.77z",
    fill: "currentColor",
    style: {
      strokeWidth: 2.6662
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.f6760d47.svg";
export { ForwardRef as ReactComponent };